import { createSlice } from "@reduxjs/toolkit";

const refListSlice = createSlice({
  name: "refLists",
  initialState: {
    refLists: null,
    refListItemContexts: [],
    isLoading: true,
  },
  reducers: {
    setRefLists: (state, action) => {
      state.refLists = action.payload;
    },
    getRefLists: (state) => {
      return state.refLists;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setRefListItemContexts: (state, action) => {
      state.refListItemContexts = action.payload;
    },
  },
});

export const { setRefLists, getRefLists, setLoading, setRefListItemContexts } = refListSlice.actions;
export default refListSlice.reducer;
